<div #datepickerContainer>
  <dp-date-picker id="datepicker" #dayPicker
    [required]="required"
    [displayDate]="displayDate"
    [config]="config"
    [(ngModel)]="date">
  </dp-date-picker>
</div>
